module.exports = __webpack_public_path__ + "img/banner-2.bdb86a95.jpg";